import React from 'react';
import { headingFontBold, vars } from '../../../../../Theme';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReleaseTypeEnum } from '../../../../../redux/project/sliceProjectWorkflow';

const getChipSx = (releaseType: ReleaseTypeEnum) => {
    const colors = {
        new_document: vars.trafficLightGreen,
        new_index: vars.tagChipBlue,
        invalid: vars.errorDialogRed,
    };

    return {
        ml: '8px',
        height: '27px',
        backgroundColor: colors[releaseType],
        color: vars.white,
        fontFamily: headingFontBold,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineLeight: 'normal',
        cursor: 'inherit',
    };
};

export default ({ releaseType }: { releaseType: ReleaseTypeEnum }) => {
    const { t } = useTranslation('translations', { keyPrefix: 'initialReleaseDialog' });

    return <Chip label={t(releaseType)} sx={getChipSx(releaseType)} />;
};
